export enum MainRoutes {
  ADMIN = '/admin',
  CMS = '/cms',
  DASHBOARD = '/dashboard',
  ENTITIES = '/entities',
  FEATURE = '/feature',
  HOME = '/',
  LOGIN = '/login',
  MESSAGE_CENTER = '/message-center',
  NEW_PASSWORD = '/newpassword',
  PROFILE = '/profile',
  QUEUE = '/queue',
  RECENTLY_VIEWED_PATIENTS = '/recentlyviewedpatients',
  REPORTING = '/reporting',
  REVIEWS = '/reviews',
  RR = '/rr',
  RR_REVIEWS = '/rr-reviews',
  SEARCH = '/search',
  SSO = '/sso',
  TEAM = '/team',
  USER = '/user',
}

export enum SubRoutes {
  ADMISSIONS = '/admissions',
  CHART = '/chart',
  CONTACTS = '/contacts',
  ENTITIES = '/entities',
  PATIENTS = '/patients',
  REVIEWS = '/reviews',
  RULES = '/rules',
  TEAMS = '/teams',
  VIEW_AND_DO = '/viewanddo',
}

export enum RouteParams {
  ADMISSION_ID = '/:admissionid',
  ADMISSION_ID_1 = '/:admissionId',
  ENTITY_ID = '/:entityid',
  ENTITY_ID_1 = '/:entityId',
  FEATURE_ID = '/:featureid',
  PATIENT_ID = '/:patientid',
  PATIENT_ID_1 = '/:patientId',
  REVIEW_ID = '/:reviewId',
  TAB_INDEX = '/:tabIndex',
  TEAM_ID = '/:teamId',
  TEAM_ID_1 = '/:teamid',
  USER_NAME = '/:username',
}

export enum RouteParamNames {
  ADMISSION_ID = 'admissionId',
  ENTITY_ID = 'entityId',
  FEATURE_ID = 'featureId',
  PATIENT_ID = 'patientId',
  REVIEW_ID = 'reviewId',
  TAB_INDEX = 'tabIndex',
  TEAM_ID = 'teamId',
  USER_NAME = 'username',
}

export const PATHS = {
  ADMIN: `${MainRoutes.ADMIN}`,
  ADMISSION_REVIEWS: `${MainRoutes.REVIEWS}${RouteParams.ENTITY_ID}${RouteParams.PATIENT_ID}${RouteParams.ADMISSION_ID}`,
  ADMISSION_RR_REVIEWS: `${MainRoutes.RR_REVIEWS}${RouteParams.ENTITY_ID_1}${RouteParams.ADMISSION_ID_1}`,
  CMS: `${MainRoutes.CMS}`,
  DASHBOARD: `${MainRoutes.DASHBOARD}`,
  ENTITY_CHART: `${MainRoutes.ENTITIES}${RouteParams.ENTITY_ID_1}${SubRoutes.PATIENTS}${RouteParams.PATIENT_ID_1}${SubRoutes.ADMISSIONS}${RouteParams.ADMISSION_ID_1}${SubRoutes.CHART}`,
  ENTITY_CONTACTS: `${MainRoutes.ENTITIES}${RouteParams.ENTITY_ID}${SubRoutes.CONTACTS}`,
  ENTITY_RULES: `${MainRoutes.ENTITIES}${RouteParams.ENTITY_ID}${SubRoutes.RULES}`,
  FEATURE: `${MainRoutes.FEATURE}${RouteParams.FEATURE_ID}`,
  FEATURES: `${MainRoutes.FEATURE}`,
  HOME: `${MainRoutes.HOME}`,
  LOGIN: `${MainRoutes.LOGIN}`,
  MESSAGE_CENTER: `${MainRoutes.MESSAGE_CENTER}`,
  NEW_PASSWORD: `${MainRoutes.NEW_PASSWORD}`,
  PROFILE: `${MainRoutes.PROFILE}`,
  QUEUE: `${MainRoutes.QUEUE}`,
  RECENTLY_VIEWED_PATIENTS: `${MainRoutes.RECENTLY_VIEWED_PATIENTS}`,
  REPORTING: `${MainRoutes.REPORTING}`,
  REVIEW: `${MainRoutes.ENTITIES}${RouteParams.ENTITY_ID_1}${SubRoutes.PATIENTS}${RouteParams.PATIENT_ID_1}${SubRoutes.ADMISSIONS}${RouteParams.ADMISSION_ID_1}${SubRoutes.REVIEWS}${RouteParams.REVIEW_ID}`,
  RR_ENTITY_CHART: `${MainRoutes.RR}${SubRoutes.ENTITIES}${RouteParams.ENTITY_ID_1}${SubRoutes.ADMISSIONS}${RouteParams.ADMISSION_ID_1}${SubRoutes.CHART}`,
  RR_REVIEW: `${MainRoutes.RR}${SubRoutes.ENTITIES}${RouteParams.ENTITY_ID_1}${SubRoutes.ADMISSIONS}${RouteParams.ADMISSION_ID_1}${SubRoutes.REVIEWS}${RouteParams.REVIEW_ID}`,
  SEARCH: `${MainRoutes.SEARCH}`,
  SSO: `${MainRoutes.SSO}`,
  TEAM: `${MainRoutes.TEAM}${RouteParams.TEAM_ID_1}`,
  TEAMS_QUEUE: `${MainRoutes.QUEUE}${SubRoutes.TEAMS}${RouteParams.TEAM_ID}`,
  USER: `${MainRoutes.USER}`,
  USER_NAME: `${MainRoutes.USER}${RouteParams.USER_NAME}`,
  VIEW_AND_DO: `${MainRoutes.ENTITIES}${RouteParams.ENTITY_ID_1}${SubRoutes.ADMISSIONS}${RouteParams.ADMISSION_ID_1}${SubRoutes.VIEW_AND_DO}${RouteParams.TAB_INDEX}`,
} as const;
